import { memo } from "react";
import Popover from "./popover/Popover";

function InfoButton(props: any) {
  const {
    placement = "bottom",
    style,
  } = props;
  return (
    <Popover
      component={props.children || "pass children for text"}
      placement={placement}
      delay={200}
      position={-140}
    >

      { props.icon || <i style={style} className="fa fa-question-circle pointer" /> }
    </Popover>
  );
}

export default memo(InfoButton);
